import { IconButtonWrapper } from './IconButton.styles';

type Props = {
	children: React.ReactNode;
	className?: string;
	background?: boolean;
	iconSize?: number;
	clickableSize?: number;
	onClick?: () => void;
};

export const IconButton = ({
	children,
	className,
	background = false,
	iconSize = 24,
	clickableSize = 64,
	onClick,
}: Props) => (
	<IconButtonWrapper
		type="button"
		className={className}
		background={background}
		iconSize={iconSize}
		clickableSize={clickableSize}
		onClick={onClick}
	>
		{children}
	</IconButtonWrapper>
);
